
<template>
  <!-- 集运下单 -->
  <div class="concentrated">
    <div class="concentrated_view_title">
      <span>集运下单</span>
    </div>
    <div class="concentrated_order_num">
      <div class="view_title">
        <span>物流单号：</span>
      </div>
      <el-input v-model="kdnum"
                @input="check_num()"
                placeholder="请输入已发出的快递单号"></el-input>
    </div>

    <packing-list :tableData='zxd_info'>

    </packing-list>

    <!-- 下单按钮 -->
    <div class="placeOrder_bottom">
      <el-button type="primary"
                 @click="dataVerify">确定下单</el-button>
    </div>
  </div>
</template>

<script>
import packingList from '@/components/packingList'
import common from '@/assets/js/common'
import { apiConcentrated } from '@/request/api'
export default {
  name: 'concentrated',
  data () {
    return {
      //--------装箱单数据--------
      zxd_info: [{
        no: 1,
        chang: 1,
        kuan: 1,
        gao: 1,
        weight: 1,
        wpinfo: [{
          name: '',
          enname: '',
          num: ''
        }]
      }],
      // ----------快递单号----------
      kdnum: ''
    }
  },
  components: {
    packingList
  },
  methods: {
    // -----------  下单-----------
    async placeOrder () {
      let res = await apiConcentrated({
        type: 2,
        kdnum: this.kdnum,
        zxdinfo: JSON.stringify(this.zxd_info),
        item: 'saveall'
      })

      if (res.errno == 0) {
        this.$notify({
          title: '订单下单成功',
          message: res.message,
          type: 'success',
          duration: 2000,
          close: () => {
            this.$router.go(0)
          }
        });
      } else {
        this.$message.error(res.message)
      }
    },
    // -----------  下单检测-----------
    dataVerify () {
      if (this.kdnum == '') {
        return this.$message.error('快递单号不能为空')
      }

      for (const key in this.zxd_info) {
        for (const k in this.zxd_info[key].wpinfo) {
          if (this.zxd_info[key].wpinfo[k] == '') {
            this.$message.error('装箱单物品信息未填写完整')
            return false
          }
        }
      }

      this.placeOrder()
    },
    // -----------  快递单输入限制-----------
    check_num: common.debounce(function () {
      this.kdnum = this.kdnum.replace(/[^\a-\z\A-\Z0-9\-]/g, '');
    })
  }

}
</script>

<style lang='scss'>
.concentrated {
  overflow: auto;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-top: 10px;
  display: flex;
  background-color: #fff;
  padding: 20px;

  padding-bottom: 80px;
  .concentrated_order_num {
    width: 100%;
    display: flex;
    align-items: center;
    height: 70px;
    .el-input {
      width: 300px;
    }
  }
  .concentrated_view_title {
    margin-top: 20px;
    height: 80px;
    width: 100%;
    display: flex;
    justify-content: center;
    font-size: 30px;
    color: #409eff;
    font-weight: 700;
    letter-spacing: 2px;
  }
  .placeOrder_bottom {
    height: 100px;
    background: rgba(255, 255, 255, 0.815);
    position: fixed;
    bottom: 0;
    right: 0;
    left: 10%;
    z-index: 100;
    display: flex;
    align-items: center;
    padding: 20px;
    justify-content: flex-end;
    box-sizing: border-box;
  }
}
</style>